import './StopWatch.css'
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { updateProgressElapsedTime } from '../../actions/progress';
import { useParams } from 'react-router-dom';
import { STORE_PROGRESS_ELAPSED_TIME } from '../../constants/actionConstants';

const StopWatch = () => {
    const [timer, setTimer] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [timeStarted, setTimeStarted] = useState(0) ; 
    const courseTitle = useSelector((state)=> state.CourseStructureReducer.courseTitle) ; 



    const { id } = useParams();
    const dispatch = useDispatch();

    let timeInterval = useRef(null);

    // Stopwatch stops after this many seconds if we don't do something.
    const stop_after_x_seconds = 61; 

    // Restart the timer if we find that something has happened
    const hasBeenActivity = useSelector((state) => state.ContentPositionReducer.signalStartStopwatch)
    const stopwatchPauseFlag = useSelector((state) => state.ContentPositionReducer.stopwatchPauseFlag)

    // This function is called when component unmounts to store the initial time to be read again when reopened
    // useEffect(() => {
    //     return () => {
    //       dispatch(updateProgressElapsedTime(id, timer))
    //     };
    //   }, []);


    function handleStart() {
        // Note when we started this
        setTimeStarted(timer)
        if (isRunning) 
            return;
        clearInterval(timeInterval.current);
        setIsRunning(true);
        timeInterval.current = setInterval(incrementTimer, 1000 );
    };

    useEffect(()=>{
        if(!stopwatchPauseFlag){
            handleStart() ; 
        }
    },[hasBeenActivity, stopwatchPauseFlag])

    useEffect(()=>{
        if(stopwatchPauseFlag){ handlePause() ; }
    },[stopwatchPauseFlag])

    // Look at progress reducer to load progess when open webpage
    const previousElapsedTime = useSelector((state)=> state.ProgressReducer.elapsedTime) ; 
    // console.log(previousElapsedTime)

    useEffect(()=>{
            if(previousElapsedTime!==-1)
            {
                setIsRunning(false);
                clearInterval(timeInterval.current);
                setTimeStarted(previousElapsedTime)
                setTimer(previousElapsedTime);
                // Note when we started this
                setIsRunning(true);
                timeInterval.current = setInterval(incrementTimer, 1000 ); 
            }
    }, [previousElapsedTime])

    const incrementTimer = ()=>{
        setTimer((prev) => prev + 1000);
    }

 

    const handlePause = () => {
        if (!isRunning) 
            return;
        clearInterval(timeInterval.current);
        setIsRunning(false);
        // console.log("Updating timer to ", timer)
        dispatch(updateProgressElapsedTime(id, timer, courseTitle))
    };
  

    // Pause if we haven't had an update
    if(timer >= timeStarted + stop_after_x_seconds * 1000)
    {
        handlePause();
    }

    // Store the progress once a minute
    useEffect(()=>{
        dispatch({type: STORE_PROGRESS_ELAPSED_TIME, payload:timer})

        if(Math.floor((timer / 1000) % 60) === 30)
        {
            // console.log("Updating timer to ", timer)
            dispatch(updateProgressElapsedTime(id, timer,courseTitle))
        }
    },[dispatch, id, timer])

    return (<></>)
        
}

export default StopWatch